import { startOfToday, startOfTomorrow } from "date-fns";
import {
    RelativePeriods,
    RelativePeriodStrings,
    ReportTypes,
    ValidationSchema,
} from "lib";

type ReportForm = {
    type: keyof typeof ReportTypes;
    from: Date;
    to: Date;
    period: RelativePeriodStrings;
    startOfDay: number;
};

export const defaultReportForm: ReportForm = {
    type: ReportTypes.PRODUCT_SALES,
    from: startOfToday(),
    to: startOfTomorrow(),
    period: RelativePeriods.TODAY,
    startOfDay: 0,
};

export const schemaReportForm: ValidationSchema<ReportForm> = {
    type: { required: true },
    from: { required: true },
    to: { required: true },
    startOfDay: { required: true, integer: true },
};
